// default size, color, stile and dimensions 

$(document).ready(function(){

    recent_size='';
    recent_color='';
    recent_frame_size='';
    recent_frame_style='';
  	
  	df_color = "White"
    df_stile = "Normale"
    df_frame_size = "30x30 cm" //frame size
    df_photo_size = "L"	//Photo size
    
  function update_customization(p,v){
    if(!localStorage.customizations){
      c= {color:df_color,stile:df_stile,frame:df_frame_size,photo:df_photo_size}
      localStorage.setItem('customizations',JSON.stringify(c));
    }
    
      c =  JSON.parse(localStorage.customizations);
      c[p]=v;
      localStorage.setItem('customizations',JSON.stringify(c));

    show_first_image();
  }

	$("input[name='option-1']").change(function(){
      
      c=''; 
      
      v=$(this).val();
      
      update_customization('photo',v);
      
      $("#user_image_container").removeClass("xl-image-shadow");
        switch(v){
            case "S":
      			  c='small';
      			  break;
            case "L":
       				c='large';
     	 			break;
           case "XL":
                  c='xl';
                  $("#user_image_container").addClass("xl-image-shadow");
                  break;
        }
        $("#uc-custom-image").addClass(c).removeClass(recent_size);
        recent_size=c;
	});

    $("input[name='properties[Colore]']").change(function(){
      
      	  v = $(this).val();
      
          update_customization('color',v);
      
          clr = v.trim().replace(" ","-");
          $("#user_image_container").addClass(clr).removeClass(recent_color);
          recent_color=clr;
    });
  
	$("input[name='option-0']").change(function(){

     v=$(this).val();    
     
     update_customization('frame',v);
     
     clr = "frame_"+v;
     
     $(".product_gallery .gallery-cell:first-child").addClass(clr).removeClass(recent_frame_size);
          recent_frame_size=clr;
    });
    
	$("input[name='properties[Stile]']").change(function(){
     
     v=$(this).val();    
     
     update_customization('stile',v);
     
          clr = "framming_"+v;
     $(".product_gallery .gallery-cell:first-child").addClass(clr).removeClass(recent_frame_style);
          recent_frame_style=clr;
    });
  
    
    setTimeout(function(){
      
      if(!localStorage.customizations){
        
        $("input[name='properties[Colore]']").each(function(){ 
          if($(this).val() == df_color){
     		   $(this).addClass("force_select");
       		}
		})

        $("input[name='properties[Stile]']").each(function(){ 
          if($(this).val() == df_stile){
       		 $(this).addClass("force_select");
       		}
		})

        $("input[name='option-0']").each(function(){ 
          if($(this).val() == df_frame_size){
       		 $(this).addClass("force_select");
       		}
		})

        $("input[name='option-1']").each(function(){ 
          if($(this).val() == df_photo_size){
        	$(this).addClass("force_select");
       		}
		})

	  $(".force_select").prop("checked",true).trigger("change").click(); 
        
      }
      
      else{
        
         jsn=JSON.parse(localStorage.customizations);
         $('input[value="'+jsn.frame+'"]'+','+'input[value="'+jsn.color+'"]' + ','+ 'input[value="'+jsn.stile+'"]' +','+ 'input[value="'+jsn.photo+'"]').prop('checked',true).trigger("change").click();

      }
  },200);

    $("#lt, #rt").click(function(){
      
       w =  $(".color-slider-clipper").width();
      let sig;
      if($(this).is("#rt"))
        sig= "+="+w;
      else
        sig= "-="+w;
      
      $(".color-slider-clipper").animate({scrollLeft:sig});
      
    });
    
  // mobile product options pop-up bar
  $(".mob_label").click(function(){

    if($(this).next().hasClass("mob_opt_bar_open")){
		
		$(".mob_opt_bar").removeClass("mob_opt_bar_open");
      	$(this).removeClass("active");
    }

    else{
		$(".mob_opt_bar").removeClass("mob_opt_bar_open");
      	$(".mob_label").removeClass("active");
		$(this).addClass("active").next().addClass("mob_opt_bar_open");
 
      
    }

});//end onclick
  
  $(".mob_opt_bar_close").click(function(){
    $(".mob_opt_bar").removeClass("mob_opt_bar_open");
    $(".mob_label").removeClass("active");
  });
    
 // $(".color-banner").css('width',78*$('.swatch-element.color').length+"px");
  
  
  
  $(".option_title.dettagli_label,.option_title.dsk_label").click(function(){ // accordion in desktop
    
    p=this;
    
    $(".option_title.dettagli_label,.option_title.dsk_label").each(function(){
      
      if(p!=this)
        
      	$(this).parent().removeClass("loaded");
      
    });
    
    $(this).parent().toggleClass("loaded");
  });
  
  
 window.resolve_image_names = function(){
  $(".name_resolve").each(function(){
     
    
      $.getJSON({url:"https://upload.uploadcare.com/info/?pub_key="+UPLOADCARE_PUBLIC_KEY+"&file_id="+$(this).text(),
                 context:this,
                 success:function(d){
                   $(this).text(d.filename);
                     console.log(this);
                }
    });
    });
  };
  resolve_image_names();
  
  function show_first_image(){
    $(".product_gallery_nav .gallery-cell:nth-child(1)").trigger("click");
  }
  
});// document.ready